import { FC } from 'react';
import Button from '@/components/new-design/Button';
import { twMerge } from 'tailwind-merge';

interface SitBackInOptions {
  onClick: () => void;
  className?: string;
}

const SitBackIn: FC<SitBackInOptions> = ({ onClick, className }) => {
  return (
    <Button
      onClick={onClick}
      type="button"
      className={twMerge(
        'mx-auto flex max-w-[33%] justify-center gap-3 rounded-[10px] bg-ph-purple p-3 px-5 text-center font-bold leading-5 text-white',
        className,
      )}
      fullWidth
    >
      Sit back
    </Button>
  );
};

export default SitBackIn;
